import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Typography,
  makeStyles,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tabs,
  Tab,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  Drawer,
  Chip,
  Collapse,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArchiveIcon from '@material-ui/icons/Archive';
import DescriptionIcon from '@material-ui/icons/Description';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
  orangeFocused: {
    backgroundColor: "transparent",
    '& .MuiInputBase-input': {
      fontSize: 'clamp(11px, 0.85vw, 14px)',
    },
    '& .MuiInputLabel-root': {
      fontSize: 'clamp(11px, 0.85vw, 14px)',
    },
    '& .MuiFormHelperText-root': {
      fontSize: 'clamp(9px, 0.72vw, 11px)',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fb741a',
    },
    '& .MuiInputLabel-outlined.Mui-focused': {
      color: '#002D55',
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 14,
      backgroundColor: '#FFFFFF',
    },
    '& .MuiSelect-selectMenu': {
      minHeight: 'unset !important',
      paddingTop: '10.5px',
      paddingBottom: '10.5px',
      lineHeight: 'normal',
      backgroundColor: "transparent",
    },
  },
  root: {
    background: "#f7faff",
    boxShadow: "0 6px 32px rgba(0,45,85,0.18)",
    borderRadius: 14,
  },
  Button: {
    color: "#FFFFFF",
    backgroundColor: "#002D55",
    borderRadius: 18,
    border: 'none',
    boxShadow: 'none',
    padding: 'clamp(4px, 0.39vw, 6px) clamp(10px, 1.04vw, 16px)',
    fontSize: 'clamp(0.72rem, calc(2px + 0.722vw), 1.0rem)',
    border: '2px solid transparent',
    marginRight: 'clamp(6px, 0.52vw, 8px)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: "#fb741a",
    }
  },
  closeIconButton: {
    backgroundColor: '#e6eaf0',
    color: '#002D55',
    fontWeight: 'bold',
    padding: 'clamp(4px, 0.39vw, 6px) clamp(10px, 1.04vw, 16px)',
    fontSize: 'clamp(0.72rem, calc(2px + 0.722vw), 1.0rem)',
    border: '2px solid transparent',
    borderRadius: 18,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#e6eaf0',
      color: '#FF7F27',
      border: '2px solid #FF7F27',
      boxShadow: 'none',
    },
  },
  card: {
    background: '#f7faff',
    borderRadius: 14,
  },
  cardContent: {
    background: '#f7faff',
    borderRadius: 8,
    fontSize: 'clamp(12px, 1vw, 16px)',
    padding: 24,
  },
  cardHeaderRoot: {
    height: 'clamp(42px, calc(24px + 1.45vw), 56px)',
    minHeight: 'clamp(42px, calc(24px + 1.45vw), 56px)',
    padding: '0 clamp(10px, calc(2px + 0.625vw), 16px)',
    boxSizing: 'border-box',
    borderBottom: '2px solid #fb741a',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    '& .MuiCardHeader-content': {
      overflow: 'hidden',
    },
  },
  cardHeaderTitle: {
    color: "#002D55",
    fontWeight: "bold",
    fontSize: 'clamp(15px, 1.4vw, 22px)',
    paddingLeft: 'clamp(5px, calc(2px + 0.625vw), 5px)',
  },
  bodyText: {
    color: "#666666",
    marginBottom: 12,
    fontSize: 'clamp(12px, 1vw, 15px)',
  },
  input: {},
  statsRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    marginBottom: 16,
    marginTop: 16,
    padding: 12,
    backgroundColor: "#E3F2FD",
    borderRadius: 18,
  },
  statItem: {
    flex: 1,
    textAlign: 'center',
  },
  statLabel: {
    fontSize: 'clamp(11px, 0.9vw, 14px)',
    color: "#666666",
    fontWeight: '600',
    marginBottom: 4,
  },
  statValue: {
    fontSize: 'clamp(12px, 1vw, 16px)',
    color: "#002D55",
    fontWeight: 'bold',
  },
  accordionTitle: {
    color: "#002D55",
    fontWeight: '600',
    fontSize: 'clamp(12px, 0.9vw, 14px)',
  },
  addButton: {
    backgroundColor: "#002D55",
    color: "#FFFFFF",
    borderRadius: 18,
    marginRight: 8,
    marginLeft: 8,
    '&:hover': {
      backgroundColor: "#001a3a",
    }
  },
  insuranceTab: {
    textTransform: 'none',
    borderRadius: 8,
    minHeight: 40,
    padding: '4px 12px',
    color: '#002D55',
    fontWeight: 600,
    fontSize: 'clamp(12px, 0.85vw, 14px)',
    backgroundColor: '#FFFFFF',
    '&.MuiTab-root': {
      minHeight: 40,
    },
    '&.MuiTab-labelIcon': {
      minHeight: 40,
      paddingTop: 4,
    },
    '&$selected': {
      color: '#002D55',
      backgroundColor: '#FFFFFF',
    },
    '&.Mui-selected': {
      color: '#002D55',
    },
    '&:hover': {
      color: '#fb741a',
    },
  },
  addInlineTab: {
    '& .MuiTab-wrapper': {
      flexDirection: 'row',
      alignItems: 'center',
    },
    '& .MuiTab-iconWrapper': {
      marginBottom: 0,
      marginRight: 6,
    },
  },
  selected: {},
  tabsWrapper: {
    borderRadius: 12,
    overflow: 'visible',
    '&:hover $tabsIndicator': {
      backgroundColor: '#002D55',
    },
  },
  tabsFlexContainer: {
    gap: 8,
    paddingRight: 8,
  },
  tabsIndicator: {
    backgroundColor: '#fb741a',
    height: 3,
  },
  selectedReferralItem: {
    backgroundColor: '#E3F2FD',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#BBDEFB',
    }
  },
  referralDetailsCard: {
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: 14,
    padding: 16,
    marginTop: 16,
  },
  removeButton: {
    backgroundColor: '#d32f2f',
    color: '#FFFFFF',
    borderRadius: 18,
    padding: '4px 8px',
    fontSize: 'clamp(10px, 0.78vw, 12px)',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#b71c1c',
    }
  },
  referralDropdown: {
    borderRadius: 14,
    '& .MuiOutlinedInput-root': {
      borderRadius: 14,
      color: '#002D55',
      fontWeight: 600,
      fontSize: 'clamp(11px, 0.85vw, 14px)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ddd',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fb741a',
    },
    '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fb741a',
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fb741a',
    },
    '& .MuiSelect-root[aria-expanded="true"] ~ .MuiOutlinedInput-notchedOutline': {
      borderColor: '#fb741a',
    },
  },
}));

const Insurance = ({ className, ...rest }) => {
  const classes = useStyles();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.user);
  const backendBaseUrl = process.env.REACT_APP_BACKEND_URL || 'https://api.virtus-one.com';
  
  // Multi-insurance support with tabs
  const [insuranceRecords, setInsuranceRecords] = useState([]);
  const [currentTabIndex, setCurrentTabIndex] = useState(0);
  const [showInsuranceFields, setShowInsuranceFields] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [showAddReferralForm, setShowAddReferralForm] = useState(false);
  const [usageDrawerOpen, setUsageDrawerOpen] = useState(false);
  const [allAppointments, setAllAppointments] = useState([]);
  const [referralInvoices, setReferralInvoices] = useState([]);
  const [invoicesDrawerTab, setInvoicesDrawerTab] = useState(0);
  const [loadingInvoices, setLoadingInvoices] = useState(false);
  const [showInlinePolicyPanel, setShowInlinePolicyPanel] = useState(false);
  const [showUploadSection, setShowUploadSection] = useState({});
  const [showDocumentViewer, setShowDocumentViewer] = useState(false);
  const [viewingDocument, setViewingDocument] = useState(null);
  const [viewingDocumentName, setViewingDocumentName] = useState('');

  // Clinic-level insurer agreements for linking
  const [clinicAgreements, setClinicAgreements] = useState([]);
  const [clinicAgreementsLoading, setClinicAgreementsLoading] = useState(false);
  const [pendingAgreementId, setPendingAgreementId] = useState('');

  const patientId = user && (user.id || user.user_id || user.userId || user.uuid);
  const careProviderId = user?.care_provider_unit?.id || user?.care_provider?.id || user?.careProvider?.id || user?.id || '';

  const getProviderDetailsSnapshot = (insurance = {}) => ({
    provider: String(insurance.provider || '').trim(),
    billingEmail: String(insurance.billingEmail || '').trim(),
    planType: String(insurance.planType || '').trim(),
    policyNumber: String(insurance.policyNumber || '').trim(),
    memberId: String(insurance.memberId || '').trim(),
    groupNumber: String(insurance.groupNumber || '').trim(),
    agreementId: String(insurance.agreementId || ''),
  });

  // Helper functions for multi-insurance management
  const getCurrentInsurance = () => {
    if (!insuranceRecords || insuranceRecords.length === 0) {
      return {
        id: null,
        provider: '',
        billingEmail: '',
        planType: '',
        policyNumber: '',
        memberId: '',
        groupNumber: '',
        approvedTreatments: '',
        totalCostAmount: '',
        coverageValidFrom: '',
        coverageValidUntil: '',
        referralNotes: '',
        referralLetters: [],
        activeReferralLetterIds: [],
        activeReferralLetterId: '',
        newReferralId: '',
        newReferralTitle: '',
        newReferralValidFrom: '',
        newReferralValidUntil: '',
        newReferralPolicyNumber: '',
        newReferralMemberId: '',
        newReferralGroupNumber: '',
        newReferralApprovedTreatments: '',
        newReferralApprovedAmount: '',
        newReferralPolicyEvidenceFile: null,
        newReferralPolicyEvidenceFileName: '',
        creatingReferral: false,
        policyEvidenceFile: null,
        policyEvidenceFileName: '',
        policyDocumentAnalysis: null,
        policyDocumentQuota: null,
        policyDocumentAnalysisError: '',
        newReferralPolicyDocumentAnalysis: null,
        newReferralPolicyDocumentQuota: null,
        newReferralPolicyDocumentAnalysisError: '',
        isPendingReview: false,
        pendingReason: '',
        agreementId: '',
      };
    }

    return insuranceRecords[currentTabIndex] || insuranceRecords[0];
  };

  const updateCurrentInsurance = (field, value) => {
    setInsuranceRecords((prev) => {
      const updated = [...prev];
      if (updated[currentTabIndex]) {
        updated[currentTabIndex] = {
          ...updated[currentTabIndex],
          [field]: value,
        };
      }
      return updated;
    });
  };

  const addNewInsurance = (initialValues = {}) => {
    const newInsurance = {
      id: null,
      provider: '',
      billingEmail: '',
      planType: '',
      policyNumber: '',
      memberId: '',
      groupNumber: '',
      approvedTreatments: '',
      totalCostAmount: '',
      coverageValidFrom: '',
      coverageValidUntil: '',
      referralNotes: '',
      referralLetters: [],
      activeReferralLetterIds: [],
      activeReferralLetterId: '',
      newReferralId: '',
      newReferralTitle: '',
      newReferralValidFrom: '',
      newReferralValidUntil: '',
      newReferralPolicyNumber: '',
      newReferralMemberId: '',
      newReferralGroupNumber: '',
      newReferralApprovedTreatments: '',
      newReferralApprovedAmount: '',
      newReferralPolicyEvidenceFile: null,
      newReferralPolicyEvidenceFileName: '',
      creatingReferral: false,
      policyEvidenceFile: null,
      policyEvidenceFileName: '',
      policyDocumentAnalysis: null,
      policyDocumentQuota: null,
      policyDocumentAnalysisError: '',
      newReferralPolicyDocumentAnalysis: null,
      newReferralPolicyDocumentQuota: null,
      newReferralPolicyDocumentAnalysisError: '',
      isPendingReview: false,
      pendingReason: '',
      agreementId: '',
      isNew: true,
      ...initialValues,
    };
    newInsurance.providerDetailsBaseline = getProviderDetailsSnapshot(newInsurance);
    setInsuranceRecords((prev) => [...prev, newInsurance]);
    setCurrentTabIndex(insuranceRecords.length);
    setShowInsuranceFields(true);
  };

  const deleteInsurance = async (index) => {
    const insurance = insuranceRecords[index];
    if (insurance && insurance.id) {
      if (!window.confirm('Are you sure you want to delete this insurance record?')) {
        return;
      }
      try {
        const response = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${insurance.id}/`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          throw new Error('Failed to delete insurance');
        }
      } catch (error) {
        console.error('Failed to delete insurance:', error);
        alert('Failed to delete insurance record.');
        return;
      }
    }
    
    setInsuranceRecords((prev) => {
      const updated = prev.filter((_, i) => i !== index);
      return updated;
    });
    
    if (currentTabIndex >= index && currentTabIndex > 0) {
      setCurrentTabIndex(currentTabIndex - 1);
    }
    
    if (insuranceRecords.length === 1) {
      setShowInsuranceFields(false);
    }
  };

  const currentIns = getCurrentInsurance();
  const policyEvidencePreviewSrc = currentIns.policyEvidenceFile
    ? (String(currentIns.policyEvidenceFile).startsWith('data:')
      ? currentIns.policyEvidenceFile
      : `data:application/pdf;base64,${currentIns.policyEvidenceFile}`)
    : '';
  const currentProviderDetailsSnapshot = getProviderDetailsSnapshot(currentIns);
  const providerDetailsBaseline = currentIns.providerDetailsBaseline || getProviderDetailsSnapshot();
  const showProviderDetailsSaveButton = JSON.stringify(currentProviderDetailsSnapshot) !== JSON.stringify(providerDetailsBaseline);
  const [referralSubTab, setReferralSubTab] = useState(0);
  const [selectedReferralId, setSelectedReferralId] = useState(null);

  const isReferralExpired = (letter) => {
    if (!letter) return false;
    if (String(letter.status || '').toLowerCase() === 'expired') return true;
    if (!letter.valid_until) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const validUntil = new Date(letter.valid_until);
    validUntil.setHours(0, 0, 0, 0);
    return validUntil < today;
  };

  const getShortDocumentLabel = (referral) => {
    const label = referral.title || referral.referral_id || 'Document';
    if (label.length > 30) {
      return '...' + label.slice(-27); // 3 dots + 27 chars = 30 total
    }
    return label;
  };

  const handleRemoveReferralLetter = async (letterId) => {
    if (!window.confirm('Are you sure you want to remove this referral letter?')) {
      return;
    }
    try {
      const response = await fetch(`${backendBaseUrl}/profile/patient/insurance/referral-letters/${letterId}/`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Token ${token}`,
        },
      });
      if (response.ok) {
        setInsuranceRecords((prev) => {
          const updated = [...prev];
          if (updated[currentTabIndex]) {
            updated[currentTabIndex] = {
              ...updated[currentTabIndex],
              referralLetters: updated[currentTabIndex].referralLetters.filter((r) => r.id !== letterId),
            };
          }
          return updated;
        });
        if (selectedReferralId === letterId) {
          setSelectedReferralId(null);
        }
      } else {
        alert('Failed to remove referral letter');
      }
    } catch (error) {
      console.error('Error removing referral letter:', error);
      alert('Error removing referral letter');
    }
  };

  const currentReferralLetters = currentIns.referralLetters.filter((letter) => !isReferralExpired(letter));
  const previousReferralLetters = currentIns.referralLetters.filter((letter) => isReferralExpired(letter));

  // Update selected referral's policy details
  const updateSelectedReferralPolicyDetail = (field, value) => {
    setInsuranceRecords((prev) => {
      const updated = [...prev];
      if (updated[currentTabIndex] && updated[currentTabIndex].referralLetters) {
        updated[currentTabIndex] = {
          ...updated[currentTabIndex],
          referralLetters: updated[currentTabIndex].referralLetters.map((letter) => {
            if (letter.id === selectedReferralId) {
              return { ...letter, [field]: value };
            }
            return letter;
          })
        };
      }
      return updated;
    });
  };

  // Auto-select the latest referral letter
  useEffect(() => {
    const lettersToCheck = referralSubTab === 0 ? currentReferralLetters : previousReferralLetters;
    
    if (lettersToCheck && lettersToCheck.length > 0) {
      const latestLetter = lettersToCheck[0];
      if (!selectedReferralId || !lettersToCheck.find(l => l.id === selectedReferralId)) {
        setSelectedReferralId(latestLetter.id);
      }
    } else {
      setSelectedReferralId(null);
    }
  }, [currentIns.referralLetters, selectedReferralId, referralSubTab]);

  const selectedReferral = currentIns.referralLetters?.find((l) => l.id === selectedReferralId);
  const policyScanStatus = String(currentIns.policyEvidenceUploadStatus || '').toLowerCase();
  const isPolicyScanInProgress = policyScanStatus === 'pending' || policyScanStatus === 'scanning';
  const isPolicyScanRejected = policyScanStatus === 'rejected' || policyScanStatus === 'failed';
  const isPolicySaveBlocked = isPolicyScanInProgress || isPolicyScanRejected
    || Boolean(currentIns.policyEvidenceUploadId && policyScanStatus !== 'clean');
  const hasPolicyAwaitingSave = !currentIns.id && currentIns.policyEvidenceUploadId && policyScanStatus === 'clean';
  const newReferralDocumentScanStatus = String(currentIns.newReferralDocumentUploadStatus || '').toLowerCase();
  const isNewReferralDocumentScanInProgress = newReferralDocumentScanStatus === 'pending' || newReferralDocumentScanStatus === 'scanning';
  const isNewReferralDocumentScanRejected = newReferralDocumentScanStatus === 'rejected' || newReferralDocumentScanStatus === 'failed';
  const isReferralCreateBlocked = Boolean(currentIns.newReferralDocumentUploadId && newReferralDocumentScanStatus !== 'clean');

  const readFileAsDataUrl = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target.result);
    reader.onerror = () => reject(new Error('Failed to read selected file'));
    reader.readAsDataURL(file);
  });

  const updateDocumentAnalysisState = (fieldPrefix, analysisResponse) => {
    const quota = analysisResponse?.quota || null;
    updateCurrentInsurance(`${fieldPrefix}DocumentAnalysis`, analysisResponse);
    updateCurrentInsurance(`${fieldPrefix}DocumentQuota`, quota ? {
      usageMonth: quota.usage_month || quota.usageMonth || '',
      quotaLimit: quota.quota_limit ?? quota.quotaLimit ?? null,
      pagesProcessed: quota.pages_processed ?? quota.pagesProcessed ?? 0,
      remainingPages: quota.remaining_pages ?? quota.remainingPages ?? null,
      isOverQuota: quota.is_over_quota ?? quota.isOverQuota ?? false,
    } : null);
    updateCurrentInsurance(`${fieldPrefix}DocumentAnalysisError`, '');
  };

  const analyzeDocumentUpload = async (file, fieldPrefix) => {
    if (!token || !backendBaseUrl) return null;

    const payload = new FormData();
    payload.append('file', file, file.name);
    if (currentIns.id) {
      payload.append('insurance_id', currentIns.id);
    } else if (careProviderId) {
      payload.append('care_provider_id', careProviderId);
    }

    try {
      const response = await fetch(`${backendBaseUrl}/profile/insurance/document-intelligence/analyze/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
        },
        body: payload,
      });

      const responseText = await response.text();
      let responseData = {};
      if (responseText) {
        try {
          responseData = JSON.parse(responseText);
        } catch (parseError) {
          responseData = { error: responseText };
        }
      }

      if (!response.ok) {
        const remainingPages = responseData?.remaining_pages;
        const quotaMessage = remainingPages != null
          ? ` Remaining pages this month: ${remainingPages}.`
          : '';
        const message = responseData?.detail || responseData?.error || 'Document analysis failed';
        updateCurrentInsurance(`${fieldPrefix}DocumentAnalysisError`, message);
        if (response.status === 429) {
          alert(`Document intelligence monthly quota exceeded.${quotaMessage}`);
        } else {
          alert(message);
        }
        return null;
      }

      updateDocumentAnalysisState(fieldPrefix, responseData);
      return responseData;
    } catch (error) {
      const message = error?.message || 'Document analysis failed';
      updateCurrentInsurance(`${fieldPrefix}DocumentAnalysisError`, message);
      alert(message);
      return null;
    }
  };

  useEffect(() => {
    if (!token || !currentIns.policyEvidenceUploadId || !isPolicyScanInProgress) return undefined;

    let cancelled = false;
    const refreshPolicyPreScan = async () => {
      try {
        const response = await fetch(
          `${backendBaseUrl}/profile/insurance/policy-evidence/pre-scan/${currentIns.policyEvidenceUploadId}/`,
          { headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' } }
        );
        if (!response.ok || cancelled) return;
        const upload = await response.json();
        updateCurrentInsurance('policyEvidenceUploadStatus', upload.status);
      } catch (error) {
        console.error('Failed to refresh policy scan status:', error);
      }
    };

    refreshPolicyPreScan();
    const pollId = window.setInterval(refreshPolicyPreScan, 3000);
    return () => {
      cancelled = true;
      window.clearInterval(pollId);
    };
  }, [backendBaseUrl, token, currentIns.policyEvidenceUploadId, isPolicyScanInProgress]);

  useEffect(() => {
    if (!token || !currentIns.newReferralDocumentUploadId || !isNewReferralDocumentScanInProgress) return undefined;

    let cancelled = false;
    const refreshReferralPreScan = async () => {
      try {
        const response = await fetch(
          `${backendBaseUrl}/profile/insurance/referral-documents/pre-scan/${currentIns.newReferralDocumentUploadId}/`,
          { headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' } }
        );
        if (!response.ok || cancelled) return;
        const upload = await response.json();
        updateCurrentInsurance('newReferralDocumentUploadStatus', upload.status);
      } catch (error) {
        console.error('Failed to refresh referral document scan status:', error);
      }
    };

    refreshReferralPreScan();
    const pollId = window.setInterval(refreshReferralPreScan, 3000);
    return () => {
      cancelled = true;
      window.clearInterval(pollId);
    };
  }, [backendBaseUrl, token, currentIns.newReferralDocumentUploadId, isNewReferralDocumentScanInProgress]);

  // Fetch clinic-level insurer agreements for the link dropdown
  useEffect(() => {
    if (!token || !backendBaseUrl) return;
    const fetchAgreements = async () => {
      setClinicAgreementsLoading(true);
      try {
        const res = await fetch(`${backendBaseUrl}/profile/clinic/insurance-agreements/`, {
          headers: { 'Authorization': `Token ${token}`, 'Content-Type': 'application/json' },
        });
        if (res.ok) {
          const data = await res.json();
          setClinicAgreements(Array.isArray(data) ? data : []);
        }
      } catch (err) {
        console.error('Failed to load clinic agreements:', err);
      } finally {
        setClinicAgreementsLoading(false);
      }
    };
    fetchAgreements();
  }, [backendBaseUrl, token]);
  
  // Fetch insurance and referral letters on component mount
  useEffect(() => {
    if (!token || !patientId) return;

    let mounted = true;

    const fetchReferralLetters = async (insuranceRecordId, preselectedActiveId = '') => {
      if (!insuranceRecordId) {
        return [];
      }
      try {
        const response = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${insuranceRecordId}/referral-letters/`, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          throw new Error(`Failed to load referral letters (${response.status})`);
        }
        const letters = await response.json();
        return Array.isArray(letters) ? letters : [];
      } catch (error) {
        console.error('Failed to load referral letters:', error);
        return [];
      }
    };

    const fetchInsurance = async () => {
      try {
        const response = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/`, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });

        if (!mounted) return;

        if (response.status === 404) {
          setInsuranceRecords([]);
          setShowInsuranceFields(false);
          return;
        }

        if (!response.ok) {
          throw new Error(`Failed to load insurance (${response.status})`);
        }

        const data = await response.json();
        const insuranceList = Array.isArray(data) ? data : (data?.results || (data ? [data] : []));

        if (!insuranceList || insuranceList.length === 0) {
          setInsuranceRecords([]);
          setShowInsuranceFields(false);
          return;
        }

        // Load all insurance records with their referral letters
        const recordsWithLetters = await Promise.all(
          insuranceList.map(async (ins) => {
            const letters = await fetchReferralLetters(ins.id);
            const selectedActiveId = ins.active_referral_letter
              ? String(ins.active_referral_letter)
              : (ins.active_referral_letter_details?.id ? String(ins.active_referral_letter_details.id) : '');
            
            const mappedInsurance = {
              id: ins.id,
              provider: ins.insurance_provider || '',
              billingEmail: ins.billing_email || '',
              planType: ins.plan_type || '',
              policyNumber: ins.policy_number || '',
              memberId: ins.member_id || '',
              groupNumber: ins.group_number || '',
              approvedTreatments: ins.approved_treatments == null ? '' : String(ins.approved_treatments),
              totalCostAmount: ins.total_cost_amount == null ? '' : String(ins.total_cost_amount),
              coverageValidFrom: ins.coverage_valid_from || '',
              coverageValidUntil: ins.coverage_valid_until || '',
              referralNotes: ins.referral_notes || '',
              policyEvidenceFile: ins.policy_evidence_file || null,
              policyEvidenceFileName: ins.policy_evidence_file ? 'policy_document.pdf' : '',
              policyDocumentAnalysis: null,
              policyDocumentQuota: null,
              policyDocumentAnalysisError: '',
              newReferralPolicyDocumentAnalysis: null,
              newReferralPolicyDocumentQuota: null,
              newReferralPolicyDocumentAnalysisError: '',
              isPendingReview: ins.is_pending_review || false,
              pendingReason: ins.pending_reason || '',
              agreementId: ins.agreement ? String(ins.agreement) : '',
              referralLetters: letters,
              activeReferralLetterIds: letters
                .filter((letter) => letter.is_active !== false && !isReferralExpired(letter))
                .map((letter) => String(letter.id)),
              activeReferralLetterId: selectedActiveId,
              newReferralId: '',
              newReferralTitle: '',
              newReferralValidFrom: '',
              newReferralValidUntil: '',
              newReferralPolicyNumber: '',
              newReferralMemberId: '',
              newReferralGroupNumber: '',
              newReferralApprovedTreatments: '',
              newReferralApprovedAmount: '',
              creatingReferral: false,
            };
            return {
              ...mappedInsurance,
              providerDetailsBaseline: getProviderDetailsSnapshot(mappedInsurance),
            };
          })
        );

        setInsuranceRecords(recordsWithLetters);
        setShowInsuranceFields(true);
      } catch (error) {
        console.error('Failed to load insurance details:', error);
      }
    };

    fetchInsurance();

    return () => {
      mounted = false;
    };
  }, [backendBaseUrl, token, patientId]);

  // Helper functions for appointment filtering
  const isUsageEligibleStatus = (status) => {
    const normalized = String(status || '').toLowerCase();
    return normalized !== 'cancelled' && normalized !== 'no_show' && normalized !== 'no-show';
  };

  const isInsurancePayer = (appointment) => {
    const payerType = String(appointment?.payer_type || '').toLowerCase();
    const payerAlias = String(appointment?.payer || appointment?.billing_payer || appointment?.payment_responsibility || '').toLowerCase();
    return appointment?.insurance_paid === true || payerType === 'insurance' || payerAlias === 'insurance' || payerAlias === 'insurer';
  };

  const extractAppointmentReferralId = (appointment) => {
    if (appointment?.payer_referral_letter && typeof appointment.payer_referral_letter === 'string') {
      return appointment.payer_referral_letter;
    }
    if (appointment?.payer_referral_letter?.id) {
      return appointment.payer_referral_letter.id;
    }
    return '';
  };

  // Function to refresh appointment usage data
  const refreshAppointmentUsage = async () => {
    if (!token || !patientId || !backendBaseUrl) return;
    
    try {
      const response = await fetch(`${backendBaseUrl}/api/calendar/appointments/`, {
        headers: { 'Authorization': `Token ${token}` },
      });
      if (!response.ok) return;
      const data = await response.json();
      const appointmentList = data.appointments || (Array.isArray(data) ? data : data.results || []);
      
      // Store all appointments for drawer display
      setAllAppointments(appointmentList);
      
      // Update usage for each insurance record
      setInsuranceRecords((prev) => {
        return prev.map((ins) => {
          const insuranceAppointments = appointmentList.filter((apt) => {
            if (!isUsageEligibleStatus(apt?.status)) return false;
            if (!isInsurancePayer(apt)) return false;

            const appointmentReferralId = extractAppointmentReferralId(apt);
            const activeIds = Array.isArray(ins.activeReferralLetterIds)
              ? ins.activeReferralLetterIds.filter(Boolean).map(String)
              : [];

            if (activeIds.length > 0) {
              return activeIds.includes(String(appointmentReferralId));
            }

            if (ins.activeReferralLetterId) {
              return String(appointmentReferralId) === String(ins.activeReferralLetterId);
            }
            return true;
          });
          const usedCount = insuranceAppointments.length;
          const totalAmount = insuranceAppointments.reduce((sum, apt) => (
            sum + (apt.booked_price ? Number(apt.booked_price) : 0)
          ), 0);

          return {
            ...ins,
            usedTreatments: String(usedCount),
            usedCostAmount: totalAmount.toFixed(2),
          };
        });
      });
    } catch (error) {
      console.error('Failed to load appointments for insurance usage:', error);
    }
  };

  // Load appointment usage on mount only
  useEffect(() => {
    refreshAppointmentUsage();
  }, [backendBaseUrl, token, patientId]);

  // Fetch invoices when drawer opens or referral changes
  useEffect(() => {
    if (usageDrawerOpen && selectedReferral?.id) {
      fetchReferralInvoices(selectedReferral.id);
    }
  }, [usageDrawerOpen, selectedReferral?.id, token, backendBaseUrl, patientId]);

  const fetchReferralInvoices = async (referralId) => {
    if (!token || !patientId || !referralId) {
      setReferralInvoices([]);
      return;
    }
    
    setLoadingInvoices(true);
    try {
      const response = await fetch(`${backendBaseUrl}/api/calendar/invoices/`, {
        headers: { 'Authorization': `Token ${token}` },
      });
      if (!response.ok) return;
      const data = await response.json();
      const allInvoices = Array.isArray(data) ? data : (data.invoices || data.results || []);
      
      // Filter invoices that contain line items with appointments linked to this referral
      const linkedInvoices = allInvoices.filter((inv) => {
        const lines = inv.invoice_lines || inv.line_items || [];
        if (!Array.isArray(lines) || lines.length === 0) return false;
        return lines.some((line) => {
          // Check if this appointment has payer_referral_letter matching our referralId
          const apptRef = line.appointment?.payer_referral_letter || line.appointment?.payer_referral_letter_id;
          return String(apptRef) === String(referralId) || String(line.appointment_id) === String(referralId);
        });
      });
      
      setReferralInvoices(linkedInvoices);
    } catch (error) {
      console.error('Failed to fetch invoices for referral:', error);
      setReferralInvoices([]);
    } finally {
      setLoadingInvoices(false);
    }
  };

  const handleAddReferralLetter = async () => {
    const current = getCurrentInsurance();
    if (!current.id || !current.newReferralId?.trim()) {
      alert('Enter a referral letter ID before adding.');
      return;
    }

    updateCurrentInsurance('creatingReferral', true);
    try {
      // Prepare FormData for file upload
      const formData = new FormData();
      formData.append('referral_id', current.newReferralId.trim());
      formData.append('title', current.newReferralTitle?.trim() || (current.provider ? `${current.provider} referral` : 'Referral Letter'));
      formData.append('status', 'received');
      formData.append('is_active', 'true');
      formData.append('valid_from', current.newReferralValidFrom || '');
      formData.append('valid_until', current.newReferralValidUntil || '');
      formData.append('policy_number', current.newReferralPolicyNumber || '');
      formData.append('member_id', current.newReferralMemberId || '');
      formData.append('group_number', current.newReferralGroupNumber || '');
      formData.append('approved_treatments', current.newReferralApprovedTreatments ? Number(current.newReferralApprovedTreatments) : '');
      formData.append('approved_amount', current.newReferralApprovedAmount ? Number(current.newReferralApprovedAmount) : '');
      
      if (isReferralCreateBlocked) {
        throw new Error('The referral document must pass the antivirus scan before it can be added.');
      }
      if (current.newReferralDocumentUploadId) {
        formData.append('document_upload_id', current.newReferralDocumentUploadId);
      }

      const response = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${current.id}/referral-letters/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const message = await response.text();
        throw new Error(message || 'Failed to add referral letter');
      }

      const created = await response.json();
      const isCreatedExpired = isReferralExpired(created);

      setInsuranceRecords((prev) => {
        const updated = [...prev];
        if (updated[currentTabIndex]) {
          const prevActiveIds = Array.isArray(updated[currentTabIndex].activeReferralLetterIds)
            ? updated[currentTabIndex].activeReferralLetterIds
            : [];
          updated[currentTabIndex] = {
            ...updated[currentTabIndex],
            referralLetters: [created, ...updated[currentTabIndex].referralLetters],
            activeReferralLetterId: String(created.id),
            activeReferralLetterIds: isCreatedExpired
              ? prevActiveIds
              : Array.from(new Set([String(created.id), ...prevActiveIds])),
            newReferralId: '',
            newReferralTitle: '',
            newReferralValidFrom: '',
            newReferralValidUntil: '',
            newReferralPolicyNumber: '',
            newReferralMemberId: '',
            newReferralGroupNumber: '',
            newReferralApprovedTreatments: '',
            newReferralApprovedAmount: '',
            newReferralPolicyEvidenceFile: null,
            newReferralPolicyEvidenceFileName: '',
            newReferralDocumentUploadId: '',
            newReferralDocumentUploadStatus: '',
          };
        }
        return updated;
      });

      setReferralSubTab(isCreatedExpired ? 1 : 0);
      setSelectedReferralId(created.id);
      setShowAddReferralForm(false);
      setShowInlinePolicyPanel(false);

      // Refetch referral letters to ensure document fields are populated
      try {
        const refetchResponse = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${current.id}/referral-letters/`, {
          headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
          },
        });
        if (refetchResponse.ok) {
          const updatedLetters = await refetchResponse.json();
          setInsuranceRecords((prev) => {
            const updated = [...prev];
            if (updated[currentTabIndex]) {
              updated[currentTabIndex] = {
                ...updated[currentTabIndex],
                referralLetters: Array.isArray(updatedLetters) ? updatedLetters : [],
              };
            }
            return updated;
          });
        }
      } catch (error) {
        console.error('Failed to refetch referral letters:', error);
      }

      // Refresh appointment usage after adding referral letter
      await refreshAppointmentUsage();
    } catch (error) {
      console.error('Failed to add referral letter:', error);
      alert('Failed to add referral letter.');
    } finally {
      updateCurrentInsurance('creatingReferral', false);
    }
  };

  const handleReferralDocumentUpdate = async (event, referralId) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.type !== 'application/pdf') {
      alert('Please select a valid PDF file');
      event.target.value = '';
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('PDF file must be smaller than 5MB');
      event.target.value = '';
      return;
    }

    try {
      const formData = new FormData();
      formData.append('file', file, file.name);

      const response = await fetch(`${backendBaseUrl}/profile/patient/insurance/referral-letters/${referralId}/`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Token ${token}`,
        },
        body: formData,
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(`Failed to upload document: ${errorMessage}`);
      }

      console.log('Document uploaded successfully');

      // Refetch referral letters to update the display
      const current = getCurrentInsurance();
      const refetchResponse = await fetch(`${backendBaseUrl}/profile/patient/${patientId}/insurance/${current.id}/referral-letters/`, {
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
      });
      if (refetchResponse.ok) {
        const updatedLetters = await refetchResponse.json();
        setInsuranceRecords((prev) => {
          const updated = [...prev];
          if (updated[currentTabIndex]) {
            updated[currentTabIndex] = {
              ...updated[currentTabIndex],
              referralLetters: Array.isArray(updatedLetters) ? updatedLetters : [],
            };
          }
          return updated;
        });
      }
      
      // Clear input for re-upload
      event.target.value = '';
    } catch (error) {
      console.error('Failed to upload document:', error);
      alert(`Failed to upload document: ${error.message}`);
      event.target.value = '';
    }
  };

  const queuePreScan = async (file, endpoint, label) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    const response = await fetch(`${backendBaseUrl}${endpoint}`, {
      method: 'POST',
      headers: { 'Authorization': `Token ${token}` },
      body: formData,
    });
    if (!response.ok) {
      throw new Error((await response.text()) || `Failed to upload ${label}`);
    }
    return response.json();
  };

  const handlePDFFileChange = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (file.type !== 'application/pdf') {
      alert('Please select a valid PDF file');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('PDF file must be smaller than 5MB');
      return;
    }

    try {
      const upload = await queuePreScan(file, '/profile/insurance/policy-evidence/pre-scan/', 'policy document');
      updateCurrentInsurance('policyEvidenceFile', null);
      updateCurrentInsurance('policyEvidenceFileName', file.name);
      updateCurrentInsurance('policyEvidenceUploadId', upload.id);
      updateCurrentInsurance('policyEvidenceUploadStatus', upload.status || 'pending');
      setShowInlinePolicyPanel(true);
      setShowUploadSection((prev) => ({ ...prev, [currentTabIndex]: false }));
    } catch (error) {
      console.error('Failed to upload policy document:', error);
      alert('Failed to upload policy document.');
    } finally {
      event.target.value = '';
    }
  };

  const handleReferralDocumentUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    if (file.type !== 'application/pdf') {
      alert('Please select a valid PDF file');
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert('PDF file must be smaller than 5MB');
      return;
    }

    try {
      const upload = await queuePreScan(file, '/profile/insurance/referral-documents/pre-scan/', 'referral document');
      updateCurrentInsurance('newReferralPolicyEvidenceFile', null);
      updateCurrentInsurance('newReferralPolicyEvidenceFileName', file.name);
      updateCurrentInsurance('newReferralDocumentUploadId', upload.id);
      updateCurrentInsurance('newReferralDocumentUploadStatus', upload.status || 'pending');
    } catch (error) {
      console.error('Failed to upload referral document:', error);
      alert('Failed to upload referral document.');
    } finally {
      event.target.value = '';
    }
  };

  const handleSave = async () => {
    if (!token || !patientId) {
      alert('Missing user context. Please log in again.');
      return;
    }

    const current = getCurrentInsurance();

    if (isPolicySaveBlocked) {
      alert('The insurance policy document must pass the antivirus scan before saving.');
      return;
    }

    if (showInsuranceFields && (
      !String(current.provider || '').trim()
      || !String(current.planType || '').trim()
      || !String(current.policyNumber || '').trim()
    )) {
      alert('Please enter provider name, plan type, and policy number before saving.');
      return;
    }

    const activeLetterInput = String(current.activeReferralLetterId || '').trim();
    const matchedLetter = current.referralLetters.find((letter) => (
      String(letter.id) === activeLetterInput || String(letter.referral_id) === activeLetterInput
    ));
    const activeIds = Array.isArray(current.activeReferralLetterIds)
      ? current.activeReferralLetterIds.filter(Boolean).map(String)
      : [];
    const activeReferralLetterValue = activeIds.length > 0
      ? activeIds[0]
      : (activeLetterInput ? (matchedLetter ? String(matchedLetter.id) : activeLetterInput) : null);

    setIsSaving(true);
    try {
      const payload = {
        insurance_provider: String(current.provider || '').trim(),
        billing_email: String(current.billingEmail || '').trim() || null,
        plan_type: String(current.planType || '').trim() || null,
        policy_number: String(current.policyNumber || '').trim(),
        member_id: String(current.memberId || '').trim() || null,
        group_number: String(current.groupNumber || '').trim() || null,
        approved_treatments: current.approvedTreatments ? Number(current.approvedTreatments) : null,
        total_cost_amount: current.totalCostAmount ? Number(current.totalCostAmount) : null,
        coverage_valid_from: current.coverageValidFrom || null,
        coverage_valid_until: current.coverageValidUntil || null,
        referral_notes: String(current.referralNotes || '').trim() || null,
        active_referral_letter: activeReferralLetterValue,
        policy_upload_id: current.policyEvidenceUploadId || null,
        agreement: (current.agreementId && current.agreementId !== '__other__') ? current.agreementId : null,
      };

      // Note: care_provider is set by the backend during save(), not sent in the request

      const endpoint = current.id
        ? `${backendBaseUrl}/profile/patient/insurance/${current.id}/`
        : `${backendBaseUrl}/profile/patient/${patientId}/insurance/`;

      const response = await fetch(endpoint, {
        method: current.id ? 'PATCH' : 'POST',
        headers: {
          'Authorization': `Token ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorMsg = 'Failed to save insurance details';
        try {
          // First try to get the response as text
          const text = await response.text();
          
          // Try to parse as JSON
          try {
            const errorData = JSON.parse(text);
            if (errorData.errors) {
              // Validation errors from serializer
              const errorList = Object.entries(errorData.errors)
                .map(([field, messages]) => `${field}: ${Array.isArray(messages) ? messages.join(', ') : messages}`)
                .join('\n');
              errorMsg = `Validation errors:\n${errorList}`;
            } else if (errorData.error) {
              errorMsg = errorData.error;
            } else if (errorData.detail) {
              errorMsg = errorData.detail;
            }
          } catch (parseError) {
            // If JSON parsing fails, use the raw text
            errorMsg = text || errorMsg;
          }
        } catch (e) {
          // Fallback to generic message
          console.error('Error processing response:', e);
        }
        throw new Error(errorMsg);
      }

      const saved = await response.json();
      const savedProviderDetailsBaseline = getProviderDetailsSnapshot({
        provider: saved.insurance_provider || '',
        billingEmail: saved.billing_email || '',
        planType: saved.plan_type || '',
        policyNumber: saved.policy_number || '',
        memberId: saved.member_id || '',
        groupNumber: saved.group_number || '',
        agreementId: (current.agreementId && current.agreementId !== '__other__') ? current.agreementId : '',
      });
      
      // Update the current insurance record with saved data
      setInsuranceRecords((prev) => {
        const updated = [...prev];
        if (updated[currentTabIndex]) {
          updated[currentTabIndex] = {
            ...updated[currentTabIndex],
            id: saved.id,
            provider: saved.insurance_provider || '',
            billingEmail: saved.billing_email || '',
            planType: saved.plan_type || '',
            policyNumber: saved.policy_number || '',
            memberId: saved.member_id || '',
            groupNumber: saved.group_number || '',
            approvedTreatments: saved.approved_treatments == null ? '' : String(saved.approved_treatments),
            totalCostAmount: saved.total_cost_amount == null ? '' : String(saved.total_cost_amount),
            coverageValidFrom: saved.coverage_valid_from || '',
            coverageValidUntil: saved.coverage_valid_until || '',
            referralNotes: saved.referral_notes || '',
            activeReferralLetterIds: Array.isArray(current.activeReferralLetterIds)
              ? current.activeReferralLetterIds
              : (activeReferralLetterValue ? [String(activeReferralLetterValue)] : []),
            activeReferralLetterId: activeReferralLetterValue || '',
            isNew: false,
            isPendingReview: saved.is_pending_review || false,
            pendingReason: saved.pending_reason || '',
            policyEvidenceFile: saved.policy_evidence_file || null,
            policyEvidenceFileName: saved.policy_evidence_file ? 'policy_document.pdf' : updated[currentTabIndex].policyEvidenceFileName,
            policyEvidenceUploadStatus: saved.policy_evidence_upload_status || updated[currentTabIndex].policyEvidenceUploadStatus || '',
            policyEvidenceUploadId: '',
            providerDetailsBaseline: savedProviderDetailsBaseline,
          };
        }
        return updated;
      });

      // Refresh appointment usage after save
      await refreshAppointmentUsage();

      // Save referral letter policy details for each referral
      const currentReferralLetters = Array.isArray(current.referralLetters) ? current.referralLetters : [];
      for (const letter of currentReferralLetters) {
        if (!letter?.id) continue;
        const letterPayload = {
          policy_number: letter.policy_number || null,
          member_id: letter.member_id || null,
          group_number: letter.group_number || null,
          approved_treatments: letter.approved_treatments ? Number(letter.approved_treatments) : null,
          approved_amount: letter.approved_amount ? Number(letter.approved_amount) : null,
          valid_from: letter.valid_from || null,
          valid_until: letter.valid_until || null,
        };

        try {
          const letterResponse = await fetch(
            `${backendBaseUrl}/profile/patient/insurance/referral-letters/${letter.id}/`,
            {
              method: 'PATCH',
              headers: {
                'Authorization': `Token ${token}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(letterPayload),
            }
          );

          if (!letterResponse.ok) {
            const message = await letterResponse.text();
            console.error(`Failed to save policy details for referral ${letter.id}:`, message);
          }
        } catch (error) {
          console.error(`Failed to save policy details for referral ${letter.id}:`, error);
        }
      }

      alert('Insurance details saved successfully');
    } catch (error) {
      console.error('Failed to save insurance details:', error);
      const errorMsg = error.message || 'Failed to save insurance details. Please try again.';
      alert(errorMsg);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <form
      autoComplete="off"
      noValidate
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card className={classes.card}>
        <CardHeader
          className={classes.cardHeaderRoot}
          title={<span className={classes.cardHeaderTitle}>Insurance Information</span>}
          style={{ marginBottom: 0 }}
        />
        <CardContent className={classes.cardContent}>
          {/*<Typography className={classes.bodyText}>
            Add your insurance details to enable automatic billing for treatments covered by your plan.
          </Typography>*/}
          

          {!showInsuranceFields && (
            <Box style={{ padding: '24px 0 8px' }}>
              <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 8, fontSize: 'clamp(12px, 0.9vw, 15px)' }}>
                No insurance records added yet.
              </Typography>
              <Typography style={{ color: '#666', fontSize: 'clamp(11px, 0.85vw, 14px)', marginBottom: 20 }}>
                Select your insurer from the list to open a pre-filled form.
              </Typography>
              <Grid container spacing={2} alignItems="flex-end">
                <Grid item xs={12} sm={8} md={6}>
                  <TextField
                    select
                    fullWidth
                    label="Select Insurer"
                    value={pendingAgreementId}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      if (selectedId === '__manual__') {
                        addNewInsurance({ agreementId: '__other__' });
                        setPendingAgreementId('');
                        return;
                      }
                      if (!selectedId) return;
                      const agreement = clinicAgreements.find((a) => String(a.id) === String(selectedId));
                      const initial = { agreementId: selectedId };
                      if (agreement) {
                        initial.provider = agreement.insurance_provider_name;
                        const activePayer = (agreement.payer_details || []).find((pd) => pd.payer_status === 'active');
                        if (activePayer && activePayer.billing_email) {
                          initial.billingEmail = activePayer.billing_email;
                        }
                      }
                      addNewInsurance(initial);
                      setPendingAgreementId('');
                    }}
                    variant="outlined"
                    size="small"
                    disabled={clinicAgreementsLoading}
                    className={classes.orangeFocused}
                    helperText={clinicAgreementsLoading ? 'Loading insurers...' : 'Selecting an insurer opens the form pre-filled'}
                  >
                    <MenuItem value="">
                      <em>{clinicAgreementsLoading ? 'Loading...' : 'Choose your insurer'}</em>
                    </MenuItem>
                    {clinicAgreements.filter((a) => a.is_active).map((agreement) => (
                      <MenuItem key={agreement.id} value={agreement.id}>
                        {agreement.insurance_provider_name}
                        {agreement.business_registration_number ? ` (CVR: ${agreement.business_registration_number})` : ''}
                      </MenuItem>
                    ))}
                    {clinicAgreements.filter((a) => a.is_active).length > 0 && (
                      <Divider style={{ margin: '4px 0' }} />
                    )}
                    <MenuItem value="__manual__" style={{ color: '#fb741a', fontWeight: 600 }}>
                      <AddIcon style={{ fontSize: 16, marginRight: 6 }} />
                      Add other insurance
                    </MenuItem>
                  </TextField>
                </Grid>
              </Grid>
            </Box>
          )}

          {showInsuranceFields && insuranceRecords.length > 0 && (
            <>

              <Grid container spacing={2}>
                {/* Step 1: Insurance Provider */}
                <Grid item xs={12}>
                  {/*<Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 8 }}>
                    Insurance Provider Details
                  </Typography>*/}
              <Box style={{ borderBottom: 1, borderColor: 'divider', marginBottom: 16 }}>
                <Tabs
                  value={currentTabIndex}
                  onChange={(e, newIndex) => setCurrentTabIndex(newIndex)}
                  className={classes.tabsWrapper}
                  textColor="inherit"
                  variant="scrollable"
                  scrollButtons="auto"
                  classes={{ indicator: classes.tabsIndicator, flexContainer: classes.tabsFlexContainer }}
                >
                  {insuranceRecords.map((ins, index) => (
                    <Tab
                      key={index}
                      classes={{ root: classes.insuranceTab, selected: classes.selected }}
                      label={
                        <Box display="flex" alignItems="center" style={{ gap: 4 }}>
                          <span>
                            {ins.provider && ins.provider.trim()
                              ? ins.provider 
                              : 'Insurance Provider Name'}
                          </span>
                          {insuranceRecords.length > 1 && (
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                deleteInsurance(index);
                              }}
                              style={{ marginLeft: 4, padding: 2 }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          )}
                        </Box>
                      }
                    />
                  ))}
                  <Tab
                    classes={{ root: clsx(classes.insuranceTab, classes.addInlineTab), selected: classes.selected }}
                    label="ADD NEW"
                    icon={<AddIcon style={{marginTop: 3, marginRight: 3}}/>}
                    iconPosition="start"
                    title="Add New Insurance"
                    onClick={(e) => {
                      e.preventDefault();
                      addNewInsurance();
                    }}
                  />
                </Tabs>
              </Box>
                </Grid>

                {/* Link to Clinic Agreement */}
                <Grid item xs={12} sm={2}>
                  <TextField
                    select
                    fullWidth
                    label="Autofil by select"
                    value={currentIns.agreementId || ''}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      updateCurrentInsurance('agreementId', selectedId);
                      if (selectedId && selectedId !== '__other__') {
                        const agreement = clinicAgreements.find((a) => String(a.id) === String(selectedId));
                        if (agreement) {
                          updateCurrentInsurance('provider', agreement.insurance_provider_name);
                          const activePayer = (agreement.payer_details || []).find((pd) => pd.payer_status === 'active');
                          if (activePayer && activePayer.billing_email) {
                            updateCurrentInsurance('billingEmail', activePayer.billing_email);
                          }
                        }
                      }
                    }}
                    variant="outlined"
                    size="small"
                    className={classes.orangeFocused}
                    disabled={clinicAgreementsLoading}
                    helperText={clinicAgreementsLoading ? 'Loading insurers...' : (clinicAgreements.filter(a => a.is_active).length === 0 ? 'No registered insurers available' : '')}
                  >
                    <MenuItem value="">
                      <em>{clinicAgreementsLoading ? 'Loading...' : 'Select your insurer (optional)'}</em>
                    </MenuItem>
                    {clinicAgreements.filter((a) => a.is_active).map((agreement) => (
                      <MenuItem key={agreement.id} value={agreement.id}>
                        {agreement.insurance_provider_name}
                        {agreement.business_registration_number ? ` (CVR: ${agreement.business_registration_number})` : ''}
                      </MenuItem>
                    ))}
                    {clinicAgreements.filter((a) => a.is_active).length > 0 && (
                      <Divider style={{ margin: '4px 0' }} />
                    )}
                    <MenuItem value="__other__" style={{ color: '#666', fontStyle: 'italic' }}>Other</MenuItem>
                  </TextField>
                </Grid>

                <Grid item xs={12} sm={2}>
                  <TextField
                    className={clsx(classes.orangeFocused, classes.input)}
                    fullWidth
                    label="Insurance"
                    value={currentIns.provider}
                    onChange={(e) => updateCurrentInsurance('provider', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    className={clsx(classes.orangeFocused, classes.input)}
                    fullWidth
                    label="Billing Email"
                    type="email"
                    value={currentIns.billingEmail || ''}
                    onChange={(e) => updateCurrentInsurance('billingEmail', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    className={clsx(classes.orangeFocused, classes.input)}
                    fullWidth
                    label="Plan Type"
                    value={currentIns.planType}
                    onChange={(e) => updateCurrentInsurance('planType', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    className={clsx(classes.orangeFocused, classes.input)}
                    fullWidth
                    label="Policy Number"
                    value={currentIns.policyNumber}
                    onChange={(e) => updateCurrentInsurance('policyNumber', e.target.value)}
                    variant="outlined"
                    size="small"
                  />
                </Grid>

                {showProviderDetailsSaveButton && (
                  <Grid item xs={12}>
                    <Card className={classes.card} style={{ marginTop: 16, borderRadius: 8 }}>
                      <CardContent className={classes.cardContent}>
                        <Button
                          className={classes.Button}
                          variant="contained"
                          onClick={handleSave}
                          disabled={isSaving || !showInsuranceFields || isPolicySaveBlocked}
                          fullWidth
                        >
                          {isSaving ? 'Saving...' : 'Save Provider Details'}
                        </Button>
                      </CardContent>
                    </Card>
                  </Grid>
                )}

                <Grid item xs={12}>
                  {((!showUploadSection[currentTabIndex] && currentIns.policyEvidenceFileName) || (currentIns.referralLetters && currentIns.referralLetters.some(l => l.file_url))) ? (
                    <Box style={{ border: '1px solid #E0E0E0', borderRadius: 14, padding: 12, marginTop: 8, backgroundColor: '#F5F5F5' }}>
                      <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
                        <Box style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', flex: 1 }}>
                        <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.85vw, 14px)', whiteSpace: 'nowrap' }}>📄 Insurance Policy Document:</Typography>
                          {currentIns.policyEvidenceFileName && (
                            <Chip
                              label={hasPolicyAwaitingSave
                                ? `${currentIns.policyEvidenceFileName} - scan cleared; ready to save`
                                : (isPolicyScanInProgress
                                  ? `${currentIns.policyEvidenceFileName} - scanning`
                                  : (isPolicyScanRejected
                                    ? `${currentIns.policyEvidenceFileName} - scan failed`
                                    : currentIns.policyEvidenceFileName))}
                              onClick={currentIns.policyEvidenceFile ? () => {
                                setViewingDocument(currentIns.policyEvidenceFile);
                                setViewingDocumentName(currentIns.policyEvidenceFileName);
                                setShowDocumentViewer(true);
                              } : undefined}
                              onDelete={() => {
                                updateCurrentInsurance('policyEvidenceFile', null);
                                updateCurrentInsurance('policyEvidenceFileName', '');
                                updateCurrentInsurance('policyEvidenceUploadId', '');
                                updateCurrentInsurance('policyEvidenceUploadStatus', '');
                                setShowInlinePolicyPanel(false);
                                setShowUploadSection((prev) => ({ ...prev, [currentTabIndex]: true }));
                              }}
                              style={{
                                backgroundColor: isPolicyScanRejected ? '#FFEBEE' : (isPolicyScanInProgress ? '#FFF8E1' : '#E8F5E9'),
                                color: isPolicyScanRejected ? '#C62828' : (isPolicyScanInProgress ? '#F57F17' : '#2E7D32'),
                                cursor: currentIns.policyEvidenceFile ? 'pointer' : 'default',
                                fontSize: 'clamp(12px, 0.85vw, 14px)',
                              }}
                              icon={<DescriptionIcon />}
                            />
                          )}
                        </Box>
                        {currentIns.policyEvidenceFileName && (
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => setShowUploadSection((prev) => ({ ...prev, [currentTabIndex]: true }))}
                            style={{ color: '#002D55', borderColor: '#002D55', fontSize: 'clamp(12px, 0.85vw, 14px)' }}
                          >
                            Replace
                          </Button>
                        )}
                      </Box>

                      {/* Referral Letter Documents Section */}
                      {currentIns.referralLetters && currentIns.referralLetters.some(l => l.file_url) && (
                        <Box style={{ marginTop: 12 }}>
                          <Divider style={{ margin: '8px 0' }} />
                          <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                          <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.85vw, 14px)', marginBottom: 8, marginTop: 8 }}>📄 Referral Letter for treatment:</Typography>
                            {currentIns.referralLetters.map((referral) => (
                              referral.file_url && (
                                <Chip
                                  key={referral.id}
                                  label={getShortDocumentLabel(referral)}
                                  onClick={() => {
                                    setViewingDocument(referral.file_url);
                                    setViewingDocumentName(getShortDocumentLabel(referral));
                                    setShowDocumentViewer(true);
                                  }}
                                  style={{ backgroundColor: '#E8F5E9', color: '#2E7D32', cursor: 'pointer', fontSize: 'clamp(12px, 0.85vw, 14px)' }}
                                  icon={<DescriptionIcon />}
                                />
                              )
                            ))}
                          </Box>
                        </Box>
                      )}

                      <Typography style={{ color: '#999', fontSize: 'clamp(9px, 0.72vw, 11px)', marginTop: 12, fontStyle: 'italic' }}>
                        ✓ Documents uploaded for this insurance will be displayed here. Click on the document name to view or replace it.
                      </Typography>
                    </Box>
                  ) : (
                    <Collapse in={showUploadSection[currentTabIndex] !== false}>
                      <Box style={{ border: '2px dashed #fb741a', borderRadius: 8, padding: 16, backgroundColor: '#fff9f5', marginTop: 8 }}>
                        <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 8, fontSize: 14 }}>
                          📄 Upload Insurance Policy (PDF) - Required
                        </Typography>
                        <Typography style={{ color: '#666', fontSize: 12, marginBottom: 12 }}>
                          To verify your insurance coverage, please upload a PDF copy of your insurance policy card, referral letter, or coverage document (Max 5MB).
                        </Typography>
                        <input
                          type="file"
                          accept=".pdf"
                          onChange={handlePDFFileChange}
                          style={{ display: 'block', marginBottom: 8 }}
                        />
                        {currentIns.policyDocumentQuota && (
                          <Typography style={{ color: '#002D55', fontSize: 11, marginTop: 4 }}>
                            OCR usage this month: {currentIns.policyDocumentQuota.pagesProcessed} / {currentIns.policyDocumentQuota.quotaLimit || 500} pages used, {currentIns.policyDocumentQuota.remainingPages} remaining.
                          </Typography>
                        )}
                        {currentIns.policyDocumentAnalysisError && (
                          <Typography style={{ color: '#c62828', fontSize: 11, marginTop: 4 }}>
                            {currentIns.policyDocumentAnalysisError}
                          </Typography>
                        )}
                        <Typography style={{ color: '#fb741a', fontSize: 11, marginTop: 8, fontStyle: 'italic' }}>
                          Your submission will be reviewed by our admin team for verification.
                        </Typography>
                      </Box>
                    </Collapse>
                  )}
                </Grid>

                {currentIns.isPendingReview && (
                  <Grid item xs={12}>
                    <Box style={{ backgroundColor: '#FFF3E0', border: '1px solid #FFB74D', borderRadius: 14, padding: 12 }}>
                      <Typography style={{ fontWeight: 600, color: '#E65100', fontSize: 13, marginBottom: 4 }}>
                        ⏳ Pending Admin Review
                      </Typography>
                      <Typography style={{ color: '#BF360C', fontSize: 12 }}>
                        This insurance record exceeds the default limit of 2 per patient and is awaiting admin approval. You will be notified once it's been reviewed.
                      </Typography>
                    </Box>
                  </Grid>
                )}

                {/* Document Viewer Dialog */}
                <Dialog
                  open={showDocumentViewer}
                  onClose={() => setShowDocumentViewer(false)}
                  maxWidth="md"
                  fullWidth
                  PaperProps={{ style: { borderRadius: 12 } }}
                >
                  <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#002D55', fontWeight: 600 }}>
                    {viewingDocumentName}
                    <IconButton onClick={() => setShowDocumentViewer(false)} size="small">
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent dividers>
                    {viewingDocument && (
                      <Box component="embed" src={viewingDocument.startsWith('http') ? viewingDocument : viewingDocument} type="application/pdf" style={{ width: '100%', height: 600, border: 'none' }} />
                    )}
                  </DialogContent>
                </Dialog>

                {/* Step 2: Referral Letters 
                <Grid item xs={12}>
                  <Divider style={{ margin: '16px 0' }} />
                  <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 0 }}>
                    Referral Letters
                  </Typography>
                </Grid>*/}

                <Grid item xs={12}>
                  <Collapse in={showAddReferralForm}>
                    <Box style={{ border: '1px solid #E0E0E0', borderRadius: 12, padding: 16, marginTop: 8, background: '#FAFAFA' }}>
                      <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                        <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.9vw, 16px)', textTransform: 'uppercase' }}>
                          Add New Referral Letter
                        </Typography>
                        <IconButton
                          size="small"
                          onClick={() => setShowAddReferralForm(false)}
                          className={classes.closeIconButton}
                          style={{ borderRadius: '50%', padding: 'clamp(3px, 0.39vw, 8px)' }}
                        >
                          <CloseIcon style={{ fontSize: 'clamp(0.92rem, calc(2px + 0.722vw), 1.2rem)' }} />
                        </IconButton>
                      </Box>

                      <Box style={{ marginBottom: 12 }}>
                        {currentIns.newReferralPolicyEvidenceFileName ? (
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 13, whiteSpace: 'nowrap' }}>📄 Referral Document:</Typography>
                            <Chip
                              label={isNewReferralDocumentScanInProgress
                                ? `${currentIns.newReferralPolicyEvidenceFileName} - scanning`
                                : (isNewReferralDocumentScanRejected
                                  ? `${currentIns.newReferralPolicyEvidenceFileName} - scan failed`
                                  : (currentIns.newReferralDocumentUploadId
                                    ? `${currentIns.newReferralPolicyEvidenceFileName} - scan cleared; ready to add`
                                    : currentIns.newReferralPolicyEvidenceFileName))}
                              onDelete={() => {
                                updateCurrentInsurance('newReferralPolicyEvidenceFile', null);
                                updateCurrentInsurance('newReferralPolicyEvidenceFileName', '');
                                updateCurrentInsurance('newReferralDocumentUploadId', '');
                                updateCurrentInsurance('newReferralDocumentUploadStatus', '');
                              }}
                              style={{
                                backgroundColor: isNewReferralDocumentScanRejected ? '#FFEBEE' : (isNewReferralDocumentScanInProgress ? '#FFF8E1' : '#E8F5E9'),
                                color: isNewReferralDocumentScanRejected ? '#C62828' : (isNewReferralDocumentScanInProgress ? '#F57F17' : '#2E7D32'),
                                cursor: 'pointer',
                                fontSize: 'clamp(12px, 0.85vw, 14px)',
                              }}
                              icon={<DescriptionIcon />}
                            />
                          </Box>
                        ) : (
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 13, whiteSpace: 'nowrap' }}>📄 Referral Document:</Typography>
                            <input
                              type="file"
                              accept=".pdf"
                              onChange={handleReferralDocumentUpload}
                              style={{ display: 'block' }}
                            />
                            {currentIns.newReferralPolicyDocumentQuota && (
                              <Typography style={{ color: '#002D55', fontSize: 11, marginTop: 4 }}>
                                OCR usage this month: {currentIns.newReferralPolicyDocumentQuota.pagesProcessed} / {currentIns.newReferralPolicyDocumentQuota.quotaLimit || 500} pages used, {currentIns.newReferralPolicyDocumentQuota.remainingPages} remaining.
                              </Typography>
                            )}
                            {currentIns.newReferralPolicyDocumentAnalysisError && (
                              <Typography style={{ color: '#c62828', fontSize: 11, marginTop: 4 }}>
                                {currentIns.newReferralPolicyDocumentAnalysisError}
                              </Typography>
                            )}
                            <Typography style={{ color: '#999', fontSize: 11, fontStyle: 'italic' }}>Optional - upload specific to this referral</Typography>
                          </Box>
                        )}
                      </Box>

                      {currentIns.newReferralPolicyEvidenceFile && (
                        <Box style={{ marginBottom: 12 }}>
                          <Button
                            size="small"
                            variant="outlined"
                            onClick={() => setShowInlinePolicyPanel((prev) => !prev)}
                          >
                            {showInlinePolicyPanel ? 'Hide PDF Panel' : 'Show PDF Panel'}
                          </Button>
                        </Box>
                      )}
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={currentIns.newReferralPolicyEvidenceFile && showInlinePolicyPanel ? 7 : 12}>
                          <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="New Referral Letter ID"
                                value={currentIns.newReferralId}
                                onChange={(e) => updateCurrentInsurance('newReferralId', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Referral Title (e.g. Knee, Elbow)"
                                value={currentIns.newReferralTitle || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralTitle', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Referral Valid From"
                                type="date"
                                value={currentIns.newReferralValidFrom || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralValidFrom', e.target.value)}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Referral Valid Until"
                                type="date"
                                value={currentIns.newReferralValidUntil || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralValidUntil', e.target.value)}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ shrink: true }}
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Divider style={{ margin: '8px 0' }} />
                              <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 8, marginTop: 8, fontSize: 12 }}>
                                Policy Information (Optional)
                              </Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Policy Number"
                                value={currentIns.newReferralPolicyNumber || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralPolicyNumber', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Member ID"
                                value={currentIns.newReferralMemberId || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralMemberId', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Group Number"
                                value={currentIns.newReferralGroupNumber || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralGroupNumber', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Approved Treatments"
                                type="number"
                                value={currentIns.newReferralApprovedTreatments || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralApprovedTreatments', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                              <TextField
                                className={clsx(classes.orangeFocused, classes.input)}
                                fullWidth
                                label="Approved Amount ($)"
                                type="number"
                                value={currentIns.newReferralApprovedAmount || ''}
                                onChange={(e) => updateCurrentInsurance('newReferralApprovedAmount', e.target.value)}
                                variant="outlined"
                                size="small"
                              />
                            </Grid>
                            <Grid item xs={12}>
                              <Grid container spacing={1} style={{ marginTop: 8 }}>
                                <Grid item xs={6}>
                                  <Button
                                    className={classes.Button}
                                    variant="contained"
                                    onClick={handleAddReferralLetter}
                                    disabled={currentIns.creatingReferral || !currentIns.id || isReferralCreateBlocked}
                                    fullWidth
                                  >
                                    {currentIns.creatingReferral ? 'Adding...' : 'Confirm'}
                                  </Button>
                                </Grid>
                                <Grid item xs={6}>
                                  <Button
                                    onClick={() => setShowAddReferralForm(false)}
                                    className={classes.closeIconButton}
                                    fullWidth
                                  >
                                    Cancel
                                  </Button>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>

                        {currentIns.newReferralPolicyEvidenceFile && showInlinePolicyPanel && (
                          <Grid item xs={12} md={5}>
                            <Box style={{ border: '1px solid #E0E0E0', borderRadius: 8, backgroundColor: '#FFFFFF', padding: 8 }}>
                              <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 4, fontSize: 13 }}>
                                Referral Document
                              </Typography>
                              <Typography style={{ color: '#666666', marginBottom: 8, fontSize: 11 }}>
                                Keep this open while filling the referral details.
                              </Typography>
                              <Box
                                component="embed"
                                src={String(currentIns.newReferralPolicyEvidenceFile).startsWith('data:') ? currentIns.newReferralPolicyEvidenceFile : `data:application/pdf;base64,${currentIns.newReferralPolicyEvidenceFile}`}
                                type="application/pdf"
                                style={{ width: '100%', height: 520, border: '1px solid #DDD', borderRadius: 6 }}
                              />
                            </Box>
                          </Grid>
                        )}
                      </Grid>
                    </Box>
                  </Collapse>
                </Grid>

                <Grid item xs={12}>
                  <Box style={{ borderBottom: 1, borderColor: 'divider', marginTop: 8, display: 'flex', alignItems: 'center' }}>
                    <Tabs
                      value={referralSubTab}
                      onChange={(e, newValue) => {
                        setReferralSubTab(newValue);
                        const letters = newValue === 0 ? currentReferralLetters : previousReferralLetters;
                        if (letters.length === 0) {
                          setSelectedReferralId(null);
                        } else if (!selectedReferralId || !letters.find(l => l.id === selectedReferralId)) {
                          setSelectedReferralId(letters[0].id);
                        }
                      }}
                      className={classes.tabsWrapper}
                      textColor="inherit"
                      indicatorColor="primary"
                      classes={{ indicator: classes.tabsIndicator, flexContainer: classes.tabsFlexContainer }}
                    >
                      <Tab classes={{ root: classes.insuranceTab, selected: classes.selected }} label={`Current Referral Letters (${currentReferralLetters.length})`} />
                      <Tab classes={{ root: classes.insuranceTab, selected: classes.selected }} label={`Previous Referral Letters (${previousReferralLetters.length})`} />
                      <Tab
                        classes={{ root: clsx(classes.insuranceTab, classes.addInlineTab), selected: classes.selected }}
                        label="ADD NEW"
                        icon={<AddIcon style={{marginTop: 3, marginRight: 3}} />}
                        iconPosition="start"
                        title="Add New Referral Letter"
                        onClick={() => setShowAddReferralForm(!showAddReferralForm)}
                      />
                      {/*<Button 
                        size="small" 
                        onClick={() => setShowAddReferralForm(!showAddReferralForm)}
                        //style={{ color: showAddReferralForm ? '#fb741a' : '#002D55', marginRight: 8 }}
                        className={classes.Button}
                      >
                        + Add new
                      </Button>*/}
                    </Tabs>
                  </Box>
                  <Box style={{ display: 'flex', gap: 12, alignItems: 'flex-start', marginTop: 16 }}>
                    <Select
                      className={classes.referralDropdown}
                      value={selectedReferralId || ''}
                      onChange={(e) => setSelectedReferralId(e.target.value)}
                      onClose={(e) => {
                        if (e.target) {
                          e.target.blur();
                        }
                        setTimeout(() => {
                          if (document.activeElement instanceof HTMLElement) {
                            document.activeElement.blur();
                          }
                        }, 0);
                      }}
                      variant="outlined"
                      style={{ flex: 1, minHeight: 48 }}
                    >
                      {(referralSubTab === 0 ? currentReferralLetters : previousReferralLetters).length === 0 ? (
                        <MenuItem disabled value="">
                          {referralSubTab === 0 ? 'No active non-expired referral letters.' : 'No previous expired referral letters.'}
                        </MenuItem>
                      ) : (
                        (referralSubTab === 0 ? currentReferralLetters : previousReferralLetters).map((letter) => (
                          <MenuItem key={letter.id} value={letter.id}>
                            <Box style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                              <ArchiveIcon style={{ color: '#fb741a' }} />
                              <Box>
                                <div style={{ color: '#002D55', fontWeight: 600, fontSize: 'clamp(12px, 0.85vw, 14px)' }}>
                                  {letter.referral_id} - <span style={{ color: '#fb741a', fontSize: 'clamp(12px, 0.85vw, 14px)' }}>{letter.title || 'Referral Letter'}</span>
                                </div>
                                <div style={{ fontSize: 12, color: '#666666', marginTop: 2 }}>
                                  Status: {isReferralExpired(letter) ? 'expired' : (letter.status || 'received')} | Valid: {letter.valid_from || '-'} to {letter.valid_until || '-'}
                                </div>
                              </Box>
                            </Box>
                          </MenuItem>
                        ))
                      )}
                    </Select>
                    {selectedReferral && (
                      <Button
                        className={classes.removeButton}
                        onClick={() => handleRemoveReferralLetter(selectedReferralId)}
                        style={{ marginTop: 6 }}
                      >
                        Remove
                      </Button>
                    )}
                  </Box>
                </Grid>

                {/* Step 3: Referral & Policy Details (Merged) */}
                {selectedReferral && (
                  <>
                    <Grid item xs={12}>
                      <Divider style={{ margin: '16px 0' }} />
                      <Box className={classes.referralDetailsCard}>
                        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
                          <Typography style={{ fontWeight: 600, color: '#002D55', fontSize: 'clamp(12px, 0.9vw, 16px)' }}>
                            Referral & Policy Details for: <span style={{ color: '#fb741a' }}>{selectedReferral.title || selectedReferral.referral_id}</span>
                          </Typography>
                          <Box style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                            {selectedReferral?.file_url && (
                              <Chip
                                label={getShortDocumentLabel(selectedReferral)}
                                onClick={() => {
                                  setViewingDocument(selectedReferral.file_url);
                                  setViewingDocumentName(getShortDocumentLabel(selectedReferral));
                                  setShowDocumentViewer(true);
                                }}
                                style={{ backgroundColor: '#E8F5E9', color: '#2E7D32', cursor: 'pointer', fontSize: 'clamp(12px, 0.85vw, 14px)' }}
                                icon={<DescriptionIcon />}
                              />
                            )}
                            <Button
                              component="label"
                              size="small"
                              variant="outlined"
                              style={{ color: '#002D55', borderColor: '#002D55', fontSize: 'clamp(12px, 0.85vw, 14px)' }}
                            >
                              {selectedReferral?.file_url ? 'Replace' : 'Upload'}
                              <input
                                type="file"
                                accept=".pdf"
                                onChange={(e) => handleReferralDocumentUpdate(e, selectedReferral.id)}
                                hidden
                              />
                            </Button>
                          </Box>
                        </Box>
                        
                        {/* Usage Counters - Clickable to expand details */}
                        <Box 
                          onClick={() => setUsageDrawerOpen(!usageDrawerOpen)}
                          style={{ 
                            display: 'flex', 
                            gap: 16, 
                            marginBottom: usageDrawerOpen ? 0 : 20, 
                            padding: 16, 
                            backgroundColor: '#E3F2FD', 
                            borderRadius: usageDrawerOpen ? '8px 8px 0 0' : 8,
                            cursor: 'pointer',
                            transition: 'background-color 0.2s',
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#BBDEFB'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#E3F2FD'}
                        >
                          <Box style={{ flex: 1, textAlign: 'center', borderRadius: 14 }}>
                            <Typography style={{ fontSize: 14, color: '#666666', fontWeight: 600, marginBottom: 4 }}>Treatments Used</Typography>
                            <Typography style={{ fontSize: 'clamp(14px, 1.15vw, 18px)', color: '#002D55', fontWeight: 'bold' }}>
                              {selectedReferral?.treatments_used ?? '0'} / {selectedReferral?.approved_treatments || '0'}
                            </Typography>
                          </Box>
                          <Box style={{ flex: 1, textAlign: 'center' }}>
                            <Typography style={{ fontSize: 14, color: '#666666', fontWeight: 600, marginBottom: 4 }}>Amount Used</Typography>
                            <Typography style={{ fontSize: 'clamp(14px, 1.15vw, 18px)', color: '#002D55', fontWeight: 'bold' }}>
                              ${selectedReferral?.amount_used ?? '0'} / ${selectedReferral?.approved_amount || '0'}
                            </Typography>
                          </Box>
                          <Box style={{ display: 'flex', alignItems: 'center', color: '#fb741a' }}>
                            <ExpandMoreIcon style={{ transform: usageDrawerOpen ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.3s', fontSize: 'clamp(18px, 1.4vw, 22px)' }} />
                          </Box>
                        </Box>

                        {/* Collapsible Appointment Details */}
                        <Collapse in={usageDrawerOpen} timeout="auto" unmountOnExit>
                          <Box style={{ 
                            padding: 20, 
                            backgroundColor: '#f7faff', 
                            borderRadius: '0 0 8px 8px',
                            marginBottom: 20,
                            border: '1px solid #BBDEFB',
                            borderTop: 'none'
                          }}>
                            {(() => {
                              // Calculate referral appointments for use in Tab label and content
                              const referralAppointments = allAppointments.filter((apt) => {
                                if (!isUsageEligibleStatus(apt?.status)) return false;
                                if (!isInsurancePayer(apt)) return false;
                                const appointmentReferralId = extractAppointmentReferralId(apt);
                                return String(appointmentReferralId) === String(selectedReferral.id);
                              });

                              return (
                                <>
                                  {/* Tabs for Appointments and Invoices */}
                                  <Box style={{ borderBottom: 1, borderColor: 'divider', marginBottom: 16 }}>
                                    <Tabs
                                      value={invoicesDrawerTab}
                                      onChange={(e, newValue) => setInvoicesDrawerTab(newValue)}
                                      className={classes.tabsWrapper}
                                      textColor="inherit"
                                      variant="scrollable"
                                      scrollButtons="auto"
                                      classes={{ indicator: classes.tabsIndicator, flexContainer: classes.tabsFlexContainer }}
                                    >
                                      <Tab classes={{ root: classes.insuranceTab, selected: classes.selected }} label={`Appointments (${Math.max(0, referralAppointments?.length || 0)})`} />
                                      <Tab classes={{ root: classes.insuranceTab, selected: classes.selected }} label={`Invoices (${Math.max(0, referralInvoices.length)})`} />
                                    </Tabs>
                                  </Box>

                                  {/* APPOINTMENTS TAB */}
                                  {invoicesDrawerTab === 0 && (
                                    <>
                                      {referralAppointments.length === 0 ? (
                                        <Box style={{ padding: 40, textAlign: 'center' }}>
                                          <Typography style={{ color: '#999999', fontStyle: 'italic' }}>
                                            No appointments billed to this referral letter yet
                                          </Typography>
                                        </Box>
                                      ) : (
                                        <>
                                          {referralAppointments.map((apt) => {
                                    const aptDate = new Date(apt.start_datetime);
                                    const status = String(apt.status || '').toLowerCase();
                                    const price = apt.booked_price ? Number(apt.booked_price) : 0;

                                    return (
                                      <Card key={apt.id} style={{ marginBottom: 12, border: '1px solid #e0e0e0', borderRadius: 8 }}>
                                        <CardContent style={{ padding: 16 }}>
                                          <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                                            <Box>
                                              <Typography style={{ fontSize: 16, fontWeight: 600, color: '#002D55' }}>
                                                {aptDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' })}
                                              </Typography>
                                              <Typography style={{ fontSize: 14, color: '#666666', marginTop: 4 }}>
                                                {aptDate.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                                                {apt.service_name && ` • ${apt.service_name}`}
                                              </Typography>
                                            </Box>
                                            <Box style={{ textAlign: 'right' }}>
                                              <Typography style={{ fontSize: 18, fontWeight: 'bold', color: '#002D55' }}>
                                                ${price.toFixed(2)}
                                              </Typography>
                                            </Box>
                                          </Box>

                                          <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                                            <Chip
                                              label={status}
                                              size="small"
                                              style={{
                                                backgroundColor: status === 'completed' ? '#d4edda' : 
                                                                status === 'confirmed' ? '#cce5ff' :
                                                                status === 'cancelled' ? '#f8d7da' : '#e0e0e0',
                                                color: status === 'completed' ? '#155724' :
                                                       status === 'confirmed' ? '#004085' :
                                                       status === 'cancelled' ? '#721c24' : '#666666',
                                                textTransform: 'capitalize',
                                              }}
                                            />
                                            <Chip
                                              label="Insurance"
                                              size="small"
                                              style={{
                                                backgroundColor: '#fff3cd',
                                                color: '#856404',
                                              }}
                                            />
                                            {apt.appointment_type && (
                                              <Chip
                                                label={apt.appointment_type}
                                                size="small"
                                                style={{
                                                  backgroundColor: '#f5f5f5',
                                                  color: '#666666',
                                                }}
                                              />
                                            )}
                                          </Box>

                                          {(apt.therapist_name || apt.location) && (
                                            <Box style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #f0f0f0' }}>
                                              {apt.therapist_name && (
                                                <Typography style={{ fontSize: 13, color: '#666666' }}>
                                                  <strong>Therapist:</strong> {apt.therapist_name}
                                                </Typography>
                                              )}
                                              {apt.location && (
                                                <Typography style={{ fontSize: 13, color: '#666666', marginTop: 4 }}>
                                                  <strong>Location:</strong> {apt.location}
                                                </Typography>
                                              )}
                                            </Box>
                                          )}
                                        </CardContent>
                                      </Card>
                                    );
                                  })}
                                        </>
                                      )}
                                    </>
                                  )}

                                  {/* INVOICES TAB */}
                                  {invoicesDrawerTab === 1 && (
                              <>
                                {loadingInvoices && (
                                  <Box style={{ padding: 40, textAlign: 'center' }}>
                                    <Typography style={{ color: '#666666' }}>Loading invoices...</Typography>
                                  </Box>
                                )}
                                {!loadingInvoices && referralInvoices.length === 0 && (
                                  <Box style={{ padding: 40, textAlign: 'center' }}>
                                    <Typography style={{ color: '#999999', fontStyle: 'italic' }}>
                                      No invoices found for this referral letter
                                    </Typography>
                                  </Box>
                                )}
                                {!loadingInvoices && referralInvoices.length > 0 && referralInvoices.map((invoice) => {
                                  const invDate = new Date(invoice.invoice_date);
                                  const totalAmount = invoice.total_amount ? Number(invoice.total_amount) : 0;
                                  const status = String(invoice.status || '').toLowerCase();
                                  const appointmentCount = invoice.invoice_lines?.length || 0;

                                  return (
                                    <Card key={invoice.id} style={{ marginBottom: 12, border: '1px solid #e0e0e0', borderRadius: 8 }}>
                                      <CardContent style={{ padding: 16 }}>
                                        <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
                                          <Box>
                                            <Typography style={{ fontSize: 'clamp(12px, 0.9vw, 16px)', fontWeight: 600, color: '#002D55' }}>
                                              Invoice #{invoice.invoice_number || invoice.id}
                                            </Typography>
                                            <Typography style={{ fontSize: 'clamp(11px, 0.85vw, 14px)', color: '#666666', marginTop: 4 }}>
                                              {invDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                              {appointmentCount > 0 && ` • ${appointmentCount} appointment${appointmentCount !== 1 ? 's' : ''}`}
                                            </Typography>
                                          </Box>
                                          <Box style={{ textAlign: 'right' }}>
                                            <Typography style={{ fontSize: 'clamp(14px, 1.15vw, 18px)', fontWeight: 'bold', color: '#002D55' }}>
                                              ${totalAmount.toFixed(2)}
                                            </Typography>
                                          </Box>
                                        </Box>

                                        <Box style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
                                          <Chip
                                            label={status}
                                            size="small"
                                            style={{
                                              backgroundColor: status === 'paid' ? '#d4edda' : 
                                                              status === 'sent' || status === 'reopened' || status === 'viewed' || status === 'accepted' ? '#cce5ff' :
                                                              status === 'draft' ? '#fff3cd' : '#e0e0e0',
                                              color: status === 'paid' ? '#155724' :
                                                     status === 'sent' || status === 'reopened' || status === 'viewed' || status === 'accepted' ? '#004085' :
                                                     status === 'draft' ? '#856404' : '#666666',
                                              textTransform: 'capitalize',
                                            }}
                                          />
                                        </Box>

                                        {invoice.due_date && (
                                          <Box style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #f0f0f0' }}>
                                            <Typography style={{ fontSize: 13, color: '#666666' }}>
                                              <strong>Due Date:</strong> {new Date(invoice.due_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
                                            </Typography>
                                          </Box>
                                        )}
                                      </CardContent>
                                    </Card>
                                  );
                                })}
                              </>
                            )}
                                </>
                              );
                            })()}
                          </Box>
                        </Collapse>

                        {/* Divider between referral info and policy fields */}
                        <Divider style={{ margin: '16px 0' }} />
                          <Typography style={{ fontWeight: 600, color: '#002D55', marginBottom: 16, fontSize: 'clamp(11px, 0.85vw, 14px)' }}>
                          Policy Information
                        </Typography>

                        {/* Policy Detail Fields - Grid inside the card */}
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Policy Number"
                              value={selectedReferral?.policy_number || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('policy_number', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Referral Letter ID"
                              value={selectedReferral?.referral_id || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('referral_id', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Member ID"
                              value={selectedReferral?.member_id || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('member_id', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Group Number"
                              value={selectedReferral?.group_number || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('group_number', e.target.value)}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Approved Treatments"
                              type="number"
                              value={selectedReferral?.approved_treatments ?? ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('approved_treatments', e.target.value ? parseInt(e.target.value) : '')}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Approved Amount ($)"
                              type="number"
                              value={selectedReferral?.approved_amount ?? ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('approved_amount', e.target.value ? parseFloat(e.target.value) : '')}
                              variant="outlined"
                              size="small"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Valid From"
                              type="date"
                              value={selectedReferral?.valid_from || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('valid_from', e.target.value)}
                              variant="outlined"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Valid Until"
                              type="date"
                              value={selectedReferral?.valid_until || ''}
                              onChange={(e) => updateSelectedReferralPolicyDetail('valid_until', e.target.value)}
                              variant="outlined"
                              size="small"
                              InputLabelProps={{ shrink: true }}
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              className={clsx(classes.orangeFocused, classes.input)}
                              fullWidth
                              label="Referral Notes"
                              value={currentIns.referralNotes}
                              onChange={(e) => updateCurrentInsurance('referralNotes', e.target.value)}
                              variant="outlined"
                              multiline
                              rows={3}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  </>
                )}
                {!selectedReferral && (
                  <Grid item xs={12}>
                    <Typography style={{ color: '#999999', fontStyle: 'italic', textAlign: 'center', padding: '20px 0' }}>
                      Select a referral letter to view and edit policy details
                    </Typography>
                  </Grid>
                )}
              </Grid>

              
            </>
          )}
      <Card className={classes.card} style={{ marginTop: 16, borderRadius: 8 }}>
        <CardContent className={classes.cardContent}>
          <Button
            className={classes.Button}
            variant="contained"
            onClick={handleSave}
              disabled={isSaving || !showInsuranceFields || isPolicySaveBlocked}
            fullWidth
          >
            {isSaving ? 'Saving...' : `Save Insurance Details ${insuranceRecords.length > 0 ? `(Tab ${currentTabIndex + 1})` : ''}`}
          </Button>
        </CardContent>
      </Card>
        </CardContent>
      </Card>

    </form>
  );
};

Insurance.propTypes = {
  className: PropTypes.string
};

export default Insurance;
